import axios from 'axios';

// OFFICIAL SERVER URL
const API_URL = 'https://beamserver.nsfdcdigital.in/api';

// LOCAL TEST URL (Uncomment if needed for testing)
//const API_URL = 'http://localhost:5279/api';

// const API_URL = 'http://localhost:5279/api';

// --- EXISTING FETCH FUNCTIONS ---
export const fetchLoans = () => axios.get(`${API_URL}/inquiry/loans`);
export const fetchSkills = () => axios.get(`${API_URL}/inquiry/skills`);
export const fetchWorkshops = () => axios.get(`${API_URL}/inquiry/workshops`);

// --- NEW: EXHIBITION API ---
export const fetchExhibitionNominations = async () => {
    return await axios.get(`${API_URL}/Exhibition/all`);
};

// --- USER OPERATIONS ---
export const fetchUsers = () => axios.get(`${API_URL}/user/all`);
export const createUser = (userData) => axios.post(`${API_URL}/user/create`, userData);
export const updateUser = (id, userData) => axios.put(`${API_URL}/user/${id}`, userData);
export const deleteUser = (id) => axios.delete(`${API_URL}/user/${id}`);

// --- AUTHENTICATION ---
export const adminLogin = (credentials) => axios.post(`${API_URL}/auth/admin/login`, credentials);